export const GOLF_MIN_GROSS_STROKES = 1
export const GOLF_MAX_GROSS_STROKES = 30

export function golfScoreLabelKey(par, strokes) {
  if (strokes === 1) return 'holeInOne'
  if (!Number.isInteger(par) || par <= 0) return null
  return ({ '-3': 'albatross', '-2': 'eagle', '-1': 'birdie', 0: 'par', 1: 'bogey', 2: 'doubleBogey', 3: 'tripleBogey' })[strokes - par] || null
}

export function clampGolfGrossStrokes(value) {
  const numeric = Number(value)
  if (!Number.isFinite(numeric)) return GOLF_MIN_GROSS_STROKES
  return Math.max(GOLF_MIN_GROSS_STROKES, Math.min(GOLF_MAX_GROSS_STROKES, numeric))
}
